import React, {useState} from "react";
import "./App.css";
import QuestionComponent from "./Question";
import {makeStyles} from "@material-ui/core/styles";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CardActionArea from "@material-ui/core/CardActionArea";
import BackgroundDynamic from "./backgroundimage";
import {version} from "../package.json";

import {ExecutionResult} from "graphql";

import {useHistory} from "react-router-dom";
import {
    Maybe,
    Question,
    useCreateOptionResponseMutation,
    useGetPollQuery,
} from "./generated/graphql";
import {PollProps} from "./interfaces";
import {
    DEFCON9,
    DEFCON7,
    DEFCON5,
    DEFCON4,
    DEFCON3,
    DEFCON2,
    DEFCON1,
} from "./debug.json";

const useStyles = makeStyles({
    root: {
        padding: 0,
        margin: 0,
        maxWidth: 345,
        backgroundSize: "cover",
        position: "fixed",
        minWidth: "100%",
        minHeight: "100%",
        background:
            "linear-gradient(to top, rgb(121, 108, 191, .21) 0%, " +
            "rgba(123, 68, 126, 0.90) " +
            " 100%)",
    },
    media: {
        height: 140,
    },
    contentContainer: {
        background:
            "linear-gradient(to top, rgb(121, 108, 191, .21) 0%, " +
            "rgba(123, 68, 126, 0.90) " +
            " 100%)",
        minWidth: "100%",
        minHeight: "100vh",
        // paddingBottom: 16
    },
    version: {
        marginRight: 16,
        color: "rgba(255, 255, 255, 0.21)",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    row: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
    }
});
//    backgroundColor: "rgba(255, 255, 255, 0.21)",

const Poll = (props: PollProps) => {
    const {id: pollId, onAnswer} = props;
    const classes = useStyles();

    const {loading, error, data} = useGetPollQuery({variables: {pollId}});
    const [createResponse] = useCreateOptionResponseMutation();
    const [activeOptions, setActiveOptions] = useState<number[]>([]);

    const poll = data?.getPollByClient;
    let bgImage =
        poll?.imageUrl !== null
            ? poll?.imageUrl
            : "https://sycorax.tritonite.io/titania_common";

    const onValueSelected = (questionId: number, optionId: number) => {
        let newActiveOptions = [...activeOptions];
        newActiveOptions[questionId] = optionId;
        setActiveOptions(newActiveOptions);
    };

    const onSendClicked = async () => {
        //we assume we only have 1 "true" answer to every question - the rest is "false"
        if (poll) {
            try {
                for await (const question of poll.questions.nodes) {
                    if (question && question.options) {
                        for await (const option of question.options.nodes) {
                            if (option) {
                                const value =
                                    activeOptions[question.id] === option.id ? "true" : "false";
                                if (value === "true") {
                                    await createResponse({
                                        variables: {optionId: option.id, value: value},
                                    });
                                }
                            }
                        }
                    }
                }
                onAnswer();
            } catch (err) {
                DEFCON5 && console.log(err);
            }
        }
    };

    DEFCON5 && console.log(props);
    DEFCON5 && console.log(loading);
    DEFCON5 && console.log(error);
    DEFCON5 && console.log(poll);

    let nada = <div
        style={{
            backgroundImage: `url(${bgImage})`,
        }}
        className={classes.root}>
        <Card variant="outlined" className={classes.contentContainer}>
            <Typography gutterBottom variant="h5" component="h2">
                {"Laddar..."}
            </Typography> </Card>
    </div>
    let nadaError = <div
        style={{
            backgroundImage: `url(${bgImage})`,
        }}
        className={classes.root}>
        <Card variant="outlined" className={classes.contentContainer}>
            <Typography gutterBottom variant="h5" component="h2">
                {"Some error occured. Please get back later..."}
            </Typography> </Card>
    </div>
    if (loading) return nada;
    if (error) return nadaError;


    if (!poll) {
        return (
            <div
                style={{
                    backgroundImage: `url(${bgImage})`,
                }}
                className={classes.root}>
                <Card variant="outlined" className={classes.contentContainer}>
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                            {"Poll not available..."}
                        </Typography>
                    </CardContent>
                </Card>
            </div>
        );
    }

    const questions = poll.questions.nodes as Array<Maybe<Question>>;

    return (
        <div
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
            className={classes.root}>
            <Card className={classes.contentContainer}>
                <CardContent>
                    <div className={classes.row}>
                        <Typography gutterBottom variant="h6">
                            <div>{poll.title}</div>
                        </Typography>

                    </div>
                    <Typography gutterBottom variant="body2">
                        {poll.purpose}
                    </Typography>
                    {questions.map((question: Maybe<Question>) => {
                        if (question) {
                            return (
                                <QuestionComponent
                                    key={question.id}
                                    data={question}
                                    onValueSelected={onValueSelected}
                                />
                            );
                        }
                    })}
                </CardContent>
                <CardActions>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onSendClicked}>
                        Spara
                    </Button>
                </CardActions>
                <Typography
                    className={classes.version}
                    variant="caption"
                    gutterBottom>
                    {version}
                </Typography>
            </Card>
        </div>
    );
};

export default Poll;
